import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    routes: [
    {
        path: '',
        redirect: '/home',
    },
    {
        path: '/',
        redirect: '/home'
    },
		{
			path: '/home',
			name: 'home',
			component: () => import('../pages/home.vue'),
		},
		{
			path: '/list',
			name: 'list',
			component: () => import('../pages/list.vue'),
		},
		{
			path: '/detail',
			name: 'detail',
			component: () => import('../pages/detail.vue'),
		},
		{
			path: '/email',
			name: 'email',
			component: () => import('../pages/email.vue'),
		},
		{
			path: '/form-ask',
			name: 'form-ask',
			component: () => import('../pages/formAsk.vue'),
		},
		{
			path: '/form-join',
			name: 'form-join',
			component: () => import('../pages/formJoin.vue'),
		},
		{
			path: '/presidentSpeech',
			name: 'presidentSpeech',
			component: () => import('../pages/presidentSpeech.vue'),
		}
    ]
});

// 遍历给每个页面添加标题
router.beforeEach((to, from, next) => {
	document.title = "吉林省异地商会联合会"
	next()
})

// 解决vue中编程式路由往同一地址跳转时报错的情况
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject)
	}
	return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js